var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fullyLoaded)?_c('Loading'):_c('SubscriptionForm',{attrs:{"submit":_vm.submit,"sites":_vm.sites,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }